'use client'

import {
  createContext,
  type FC,
  type PropsWithChildren,
  useContext,
} from 'react'

const FirstImpressionContext = createContext<boolean>(false)

export const useFirstImpressionContext = (): boolean =>
  useContext(FirstImpressionContext)

type FirstImpressionProviderProps = PropsWithChildren<{
  firstImpression?: boolean
}>

export const FirstImpressionProvider: FC<FirstImpressionProviderProps> = ({
  children,
  firstImpression = false,
}) => (
  <FirstImpressionContext.Provider value={firstImpression}>
    {children}
  </FirstImpressionContext.Provider>
)
